import * as Yup from 'yup'


const customerRefundBackToLocationSchema = Yup.object().shape({
  location: Yup.object().required('Required')
})

export default customerRefundBackToLocationSchema